import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}), 'GetApp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/GetApp.js
// module id = 3989
// module chunks = 2